import { useEffect, useState } from "react";
import { api } from "../../../api/client";
import { Button, Empty, Icon, Modal, Spinner, cx } from "../../../components/ui";
import TemplateRaport from "../TemplateRaport";
import { LembarCetak, cetak } from "../cetak";
import { waktuWIB } from "../logika";

// Raport terbit satu murid, untuk team leader (keputusan #13, #18): semua versinya, baca &
// cetak, dan batalkan dengan alasan wajib. Membatalkan tak menghapus apa pun — raportnya
// tetap di riwayat bertanda DIBATALKAN, dan nilai & komentar murid tak tersentuh.

const MIN_ALASAN = 5;

export default function LihatRaportTL({ murid, onTutup, onUbah, setToast }) {
  const awal = murid.riwayat.find((x) => x.berlaku) || murid.riwayat[0];
  const [pilih, setPilih] = useState(awal.id);
  const [isi, setIsi] = useState({});           // id → raport terbit
  const [galat, setGalat] = useState("");
  const [batal, setBatal] = useState(false);
  const [alasan, setAlasan] = useState("");
  const [sibuk, setSibuk] = useState(false);

  useEffect(() => {
    if (isi[pilih]) return undefined;
    let berhenti = false;
    setGalat("");
    api.getRaportTerbitTL(pilih)
      .then((r) => { if (!berhenti) setIsi((s) => ({ ...s, [pilih]: r.snapshot })); })
      .catch((err) => { if (!berhenti) setGalat(err.message || "Raport terbit gagal dimuat."); });
    return () => { berhenti = true; };
  }, [pilih, isi]);

  const snap = isi[pilih];
  const tanda = snap && snap.dibatalkan ? "DIBATALKAN" : null;

  const kirimBatal = async () => {
    setSibuk(true);
    try {
      const r = await api.batalkanRaport(pilih, alasan.trim());
      setIsi((s) => ({ ...s, [pilih]: r.snapshot }));
      if (setToast) setToast({ type: "success", message: r.message || "Raport dibatalkan." });
      setBatal(false);
      setAlasan("");
      onUbah();
    } catch (err) {
      if (setToast) setToast({ type: "error", message: err.message || "Raport gagal dibatalkan." });
    } finally {
      setSibuk(false);
    }
  };

  return (
    <Modal title={`Raport ${murid.nama}`} open onClose={() => { if (!sibuk) onTutup(); }} wide>
      <div className="flex flex-wrap gap-2" role="group" aria-label="Versi raport">
        {murid.riwayat.map((x) => {
          const d = (isi[x.id] && isi[x.id].dibatalkan) || x.dibatalkan;
          return (
            <button
              key={x.id}
              type="button"
              aria-pressed={pilih === x.id}
              onClick={() => { setPilih(x.id); setBatal(false); }}
              className={cx(
                "inline-flex items-center gap-2 rounded-xl border px-3 py-1.5 text-xs font-bold",
                pilih === x.id
                  ? "border-primary bg-primary/10 text-slate-900 dark:text-white"
                  : "border-slate-200 text-slate-600 hover:border-primary/50 dark:border-slate-700 dark:text-slate-300"
              )}
            >
              <span className="tabular-nums">{waktuWIB(x.pada)}</span>
              <span
                className={cx(
                  "rounded-full px-1.5 py-0.5 text-[10px] uppercase",
                  d ? "bg-red-500/10 text-red-600 dark:text-red-400"
                    : x.berlaku ? "bg-green-500/10 text-green-700 dark:text-green-300"
                    : "bg-slate-100 text-slate-500 dark:bg-slate-800"
                )}
              >
                {d ? "Dibatalkan" : x.berlaku ? "Berlaku" : "Versi lama"}
              </span>
            </button>
          );
        })}
      </div>

      {galat ? (
        <div className="mt-4"><Empty label={galat} /></div>
      ) : !snap ? (
        <Spinner label="Memuat raport terbit…" />
      ) : (
        <>
          <div className="my-4 flex flex-wrap items-center justify-between gap-3">
            <p className={cx("text-sm font-bold", snap.dibatalkan ? "text-red-600 dark:text-red-400" : "text-slate-600 dark:text-slate-300")}>
              {snap.dibatalkan
                ? `Dibatalkan ${waktuWIB(snap.dibatalkan.pada)} oleh ${snap.dibatalkan.oleh} — ${snap.dibatalkan.alasan}`
                : `Terbit ${waktuWIB(snap.pada)} oleh ${snap.oleh}`}
            </p>
            <div className="flex flex-wrap gap-2">
              <Button variant="secondary" onClick={() => cetak(snap.isi)}>
                <Icon name="print" />
                Cetak / Simpan PDF
              </Button>
              {!snap.dibatalkan && !batal && (
                <Button variant="danger" onClick={() => setBatal(true)}>
                  <Icon name="block" />
                  Batalkan raport ini
                </Button>
              )}
            </div>
          </div>

          {batal && (
            <div className="mb-4 rounded-xl border border-red-500/30 bg-red-500/5 p-4">
              <label htmlFor="rp-alasan-batal" className="text-sm font-bold text-slate-800 dark:text-slate-100">
                Alasan pembatalan (wajib)
              </label>
              <textarea
                id="rp-alasan-batal"
                value={alasan}
                onChange={(e) => setAlasan(e.target.value)}
                rows={2}
                maxLength={500}
                placeholder="Mis. nilai Bulan 3 salah input"
                className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary dark:border-slate-700 dark:bg-slate-800 dark:text-white"
              />
              <p className="mt-2 text-xs text-slate-500">
                Raport tak dihapus: tetap di riwayat bertanda DIBATALKAN. Nilai & komentar murid tak tersentuh, jadi trainer
                tinggal memperbaiki lalu menerbitkan ulang. Bila term sudah terkunci, buka kuncinya di Pengaturan term.
              </p>
              <div className="mt-3 flex flex-wrap justify-end gap-2">
                <Button variant="secondary" onClick={() => { setBatal(false); setAlasan(""); }} disabled={sibuk}>Batal</Button>
                <Button variant="danger" onClick={kirimBatal} disabled={sibuk || alasan.trim().length < MIN_ALASAN}>
                  {sibuk ? "Membatalkan…" : "Ya, batalkan raport"}
                </Button>
              </div>
            </div>
          )}

          <TemplateRaport isi={snap.isi} tanda={tanda} />
          <LembarCetak key={snap.id} isi={snap.isi} tanda={tanda} />
        </>
      )}
    </Modal>
  );
}
